"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendableEthersLiquity = void 0;
const sendTransaction = (tx) => tx.send();
/**
 * Ethers-based implementation of {@link @liquity/lib-base#SendableLiquity}.
 *
 * @public
 */
class SendableEthersLiquity {
    constructor(populatable) {
        this._populate = populatable;
    }
    async approveToken(tokenAddress, toAddress, amount, overrides) {
        return this._populate
            .approveERC20(tokenAddress, toAddress, amount, overrides)
            .then(sendTransaction);
    }
    async multipleApproveERC20(tokenAddresses, toAddresses, amounts) {
        return this._populate.multipleApproveERC20(tokenAddresses, toAddresses, amounts);
    }
    async mintToken(tokenAddress, overrides) {
        return this._populate.mintERC20(tokenAddress, overrides).then(sendTransaction);
    }
    async mintTokenNoLimit(tokenAddress, amount, overrides) {
        return this._populate.mintERC20NoLimit(tokenAddress, amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.openTrove} */
    async openTrove(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides) {
        return this._populate
            .openTrove(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.openTroveLeverUp} */
    async openTroveLeverUp(params, ICRWithFees, troveOpen, maxBorrowingRateOrOptionalParams, overrides) {
        return this._populate
            .openTroveLeverUp(params, ICRWithFees, troveOpen, maxBorrowingRateOrOptionalParams, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.closeTrove} */
    // @ts-expect-error: Testing
    closeTrove(overrides) {
        return this._populate.closeTrove(overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.closeTroveUnleverUp} */
    closeTroveUnleverUp(params, overrides) {
        return this._populate.closeTroveUnleverUp(params, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.adjustTrove} */
    // @ts-expect-error: Testing
    adjustTrove(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides) {
        return this._populate
            .adjustTrove(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.addCollLeverUp} */
    addCollLeverUp(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides) {
        return this._populate
            .addCollLeverUp(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.addCollLeverUp} */
    withdrawCollUnleverUp(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides) {
        return this._populate
            .withdrawCollUnleverUp(params, ICRWithFees, maxBorrowingRateOrOptionalParams, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.depositCollateral} */
    // @ts-expect-error: Testing
    depositCollateral(collaterals, ICRWithFees, overrides) {
        return this._populate
            .depositCollateral(collaterals, ICRWithFees, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.withdrawCollateral} */
    // @ts-expect-error: Testing
    withdrawCollateral(collaterals, ICRWithFees, overrides) {
        return this._populate
            .withdrawCollateral(collaterals, ICRWithFees, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.borrowSTAR} */
    // @ts-expect-error: Testing
    borrowSTAR(amount, ICRWithFees, maxBorrowingRate, overrides) {
        return this._populate
            .borrowSTAR(amount, ICRWithFees, maxBorrowingRate, overrides)
            .then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.repaySTAR} */
    // @ts-expect-error: Testing
    repaySTAR(amount, ICRWithFees, overrides) {
        return this._populate.repaySTAR(amount, ICRWithFees, overrides).then(sendTransaction);
    }
    /** @internal */
    // @ts-expect-error: Testing
    setPrice(price, overrides) {
        return this._populate.setPrice(price, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.liquidate} */
    // @ts-expect-error: Testing
    liquidate(address, liquidator, overrides) {
        return this._populate.liquidate(address, liquidator, overrides).then(sendTransaction);
    }
    depositSTARInStabilityPool(amount, overrides) {
        return this._populate.depositSTARInStabilityPool(amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.withdrawSTARFromStabilityPool} */
    // @ts-expect-error: Testing
    withdrawSTARFromStabilityPool(amount, overrides) {
        return this._populate.withdrawSTARFromStabilityPool(amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.withdrawGainsFromStabilityPool} */
    // @ts-expect-error: Testing
    withdrawGainsFromStabilityPool(overrides) {
        return this._populate.withdrawGainsFromStabilityPool(overrides).then(sendTransaction);
    }
    claimRewardsSwap(amount, overrides) {
        return this._populate.claimRewardsSwap(amount, overrides).then(sendTransaction);
    }
    stakeLPTokens(amount, overrides) {
        console.log("amount:", +amount);
        return this._populate.stakeLPTokens(amount, overrides).then(sendTransaction);
    }
    withdrawLPTokens(amount, overrides) {
        return this._populate.withdrawLPTokens(amount, overrides).then(sendTransaction);
    }
    stakeLPTokensOldFarm(amount, overrides) {
        return this._populate.stakeLPTokensOldFarm(amount, overrides).then(sendTransaction);
    }
    withdrawLPTokensOldFarm(amount, overrides) {
        return this._populate.withdrawLPTokensOldFarm(amount, overrides).then(sendTransaction);
    }
    getVePreonStakeReward(overrides) {
        return this._populate.getVePreonStakeReward(overrides).then(sendTransaction);
    }
    getFarmRewards(overrides) {
        return this._populate.getFarmRewards(overrides).then(sendTransaction);
    }
    getOldFarmRewards(overrides) {
        return this._populate.getOldFarmRewards(overrides).then(sendTransaction);
    }
    updateVEPREON(params, overrides) {
        return this._populate.updateVEPREON(params, overrides).then(sendTransaction);
    }
    notifyAllRewarders(overrides) {
        return this._populate.notifyAllRewarders(overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.transferCollateralGainToTrove} */
    // @ts-expect-error: Testing
    transferCollateralGainToTrove(overrides) {
        return this._populate.transferCollateralGainToTrove(overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.sendSTAR} */
    // @ts-expect-error: Testing
    sendSTAR(toAddress, amount, overrides) {
        return this._populate.sendSTAR(toAddress, amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.sendPREON} */
    sendPREON(toAddress, amount, overrides) {
        return this._populate.sendPREON(toAddress, amount, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.redeemSTAR} */
    // @ts-expect-error: Testing
    redeemSTAR(amount, maxRedemptionRate, overrides) {
        return this._populate.redeemSTAR(amount, maxRedemptionRate, overrides).then(sendTransaction);
    }
    /** {@inheritDoc @liquity/lib-base#SendableLiquity.claimCollateralSurplus} */
    // @ts-expect-error: Testing
    claimCollateralSurplus(overrides) {
        return this._populate.claimCollateralSurplus(overrides).then(sendTransaction);
    }
}
exports.SendableEthersLiquity = SendableEthersLiquity;
//# sourceMappingURL=SendableEthersLiquity.js.map